import { createContext, useContext, type ReactNode } from "react";

/**
 * Whether the `<booking-form>` widget is currently maximised. Provided only
 * inside the widget; components outside it read `false`.
 */
const WidgetMaximisedContext = createContext(false);
export type WidgetAutoExpandRequest = "expand" | "restore";

const WidgetAutoExpandContext = createContext<((request: WidgetAutoExpandRequest) => void) | null>(null);

export function useWidgetMaximised(): boolean {
  return useContext(WidgetMaximisedContext);
}

export function useWidgetAutoExpand(): ((request: WidgetAutoExpandRequest) => void) | null {
  return useContext(WidgetAutoExpandContext);
}

interface WidgetMaximisedProviderProps {
  readonly isMaximised: boolean;
  readonly onAutoExpandRequest?: (request: WidgetAutoExpandRequest) => void;
  readonly children: ReactNode;
}

export function WidgetMaximisedProvider({
  isMaximised,
  onAutoExpandRequest,
  children,
}: WidgetMaximisedProviderProps): React.ReactElement {
  return (
    <WidgetMaximisedContext.Provider value={isMaximised}>
      <WidgetAutoExpandContext.Provider value={onAutoExpandRequest ?? null}>
        {children}
      </WidgetAutoExpandContext.Provider>
    </WidgetMaximisedContext.Provider>
  );
}
